import { Box, Stack, Typography } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import { useProfileQuery, User } from '../../../graphql/types';
import ProfileAvatar from '../../../sections/profiles/ProfileAvatar';

interface Props {
  text: string;
}

const UserMessageCard = ({ text }: Props) => {
  const theme = useTheme();
  const { data } = useProfileQuery({ fetchPolicy: 'cache-first' });
  const currentUser = data?.profile as User | undefined;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
      <Stack direction="column" alignItems="flex-end" sx={{ maxWidth: '88%' }}>
        <Stack direction="row" spacing={1.25} alignItems="flex-start">
          <Box
            sx={{
              px: 2,
              py: 1.25,
              borderRadius: 2.5,
              borderBottomRightRadius: 6,
              bgcolor: theme.palette.primary.main,
              color: '#fff',
              boxShadow: `0 2px 10px ${alpha(theme.palette.primary.main, 0.25)}`,
            }}
          >
            <Typography sx={{
              fontSize: '0.9375rem',
              lineHeight: 1.55,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              fontWeight: 500,
            }}>
              {text}
            </Typography>
          </Box>
          <Box sx={{
            flexShrink: 0,
            mt: 0.25,
            '& .MuiAvatar-root': {
              boxShadow: `0 0 0 2px ${theme.palette.background.paper}, 0 2px 8px ${alpha(theme.palette.common.black, 0.15)}`,
            },
          }}>
            {currentUser ? (
              <ProfileAvatar user={currentUser} size="sm" />
            ) : (
              <Box sx={{
                width: 32, height: 32, borderRadius: '50%',
                bgcolor: alpha(theme.palette.text.primary, 0.08),
              }} />
            )}
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};

export default UserMessageCard;
